export enum ClassificationStatus {
    Classified = 'true',
    Unclassified = 'false'
}
